import type {RouteParams} from 'types/routes'
import {WITHOUT_AUTH_PATHS} from 'consts/paths'
import {Completed} from 'pages/withoutAuth/registrationTrial/completed'

export const RegistrationTrialRoutes: RouteParams[] = [
  {
    key: 'registration_trial_completed',
    path: WITHOUT_AUTH_PATHS.REGISTRATION_TRIAL.COMPLETED,
    component: Completed,
    exact: true,
    whiteList: [],
  },
]
